module.exports = __webpack_public_path__ + "fasaw11.png?0064319643f0c8e3b8902302e54e08c0";